import { useTranslation } from "react-i18next";
import { PAYMENT_TYPE } from "@constants";
import "./css/PaymentType.scss";
import { Controller } from "react-hook-form";
import type { FieldError, UseFormMethods } from "react-hook-form";
import { MenuItem, Typography } from "@mui/material";
import { LabeledTextField } from "@common/LabeledTextField/LabeledTextField";
import { PLACEHOLDER_OPACITY } from "../../../theme/themeConfiguration";

interface IParams {
    control: UseFormMethods["control"];
    error: FieldError | undefined;
    namePrefix?: string;
    defaultValue?: string;
    onClearError?(): void;
    clearCardError?(): void;
}

export const PaymentType = (props: IParams) => {
    const { control, error, namePrefix, defaultValue, onClearError, clearCardError } = props;
    const { t } = useTranslation(["portin", "validation"]);
    const fieldName = namePrefix ? `${namePrefix}paymentType` : "paymentType";

    return (
        <Controller
            control={control}
            defaultValue={defaultValue ?? ""}
            label="paymentType"
            name={fieldName}
            render={(renderProps) => (
                <LabeledTextField
                    className="xtest_account_type_input payment-type-field"
                    error={Boolean(error)}
                    helperText={error?.message}
                    id="payment-type"
                    inputRef={renderProps.ref}
                    isRequired
                    labelText={t("portin:accountType")}
                    margin="dense"
                    name={renderProps.name}
                    select
                    value={renderProps.value}
                    onChange={(event) => {
                        if (onClearError) {
                            onClearError();
                        }
                        clearCardError?.();
                        renderProps.onChange(event);
                    }}
                >
                    <MenuItem disabled value="">
                        <Typography sx={{ opacity: PLACEHOLDER_OPACITY }}>{t("portin:selectPaymentType")}</Typography>
                    </MenuItem>
                    {PAYMENT_TYPE.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </LabeledTextField>
            )}
            rules={{
                required: t("validation:required"),
            }}
        />
    );
};
